import {useTranslation} from "react-i18next";
import InformationDialog from "../../../common/dialog/InformationDialog";
import {SubmissionTranslKey} from "../SubmissionTranslKey";

export interface SubmissionNotReadyForAuthorizationDialogProps {
    open: boolean;
    onClose: () => void;
}

export default function SubmissionNotReadyForAuthorizationDialog(props: Readonly<SubmissionNotReadyForAuthorizationDialogProps>) {
    const {open, onClose} = props;
    const {t} = useTranslation();

    return (
        <InformationDialog
            open={open}
            onClose={onClose}
            title={t(SubmissionTranslKey.SUBMISSION_NOT_READY_FOR_AUTHORIZATION_DIALOG_TITLE)}
            primaryButton={{title: t(SubmissionTranslKey.GO_TO_DASHBOARD), onClick: onClose}}
        >
            {t(SubmissionTranslKey.SUBMISSION_NOT_READY_FOR_AUTHORIZATION_DIALOG_MESSAGE)}
        </InformationDialog>
    );
}
